import * as zExt from "@redotech/rpc/ext";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod/v4";
import { AutomationChannel } from "./advanced-flow/common";

export enum AiContextLibraryType {
  MARKETING = "MARKETING",
  SCENARIO = "SCENARIO",
  VANGUARD = "VANGUARD",
}

export const qualityValues = ["GOOD", "BAD"] as const;
export type Quality = (typeof qualityValues)[number];

const AutomationChannelValues = [
  AutomationChannel.Email,
  AutomationChannel.SMS,
] as const;

const baseSchema = z.object({
  _id: zExt.objectId(),
  team: zExt.objectId(),
  title: z.string(),
  content: z.string(),
  quality: createEnum(qualityValues),
  feedback: z.string().nullish(),
  createdAt: z.date(),
  updatedAt: z.date(),
});

const marketingSchema = baseSchema.extend({
  type: z.nativeEnum(AiContextLibraryType),
  marketingAgentPromptIds: z.array(zExt.objectId()),
  // If there is an smsTemplateId, the example is scoped to that SMS template.
  smsTemplateId: zExt.objectId().optional(),
  channel: createEnum(AutomationChannelValues),
  /** When true, uses ShopperAI to generate response instead of template content */
  useShopperAi: z.boolean().optional(),
  /** When useShopperAi is true, this discount ID will be provided to ShopperAI */
  shopperAiDiscountId: zExt.objectId().nullish(),
});

const AiContextLibrarySchema_ = marketingSchema;
export interface AiContextLibrary
  extends z.infer<typeof AiContextLibrarySchema_> {}
export const AiContextLibrarySchema: z.ZodType<AiContextLibrary> =
  AiContextLibrarySchema_;
